import React, { useState } from "react";

export default function TrackOrder() {
  const [orderId, setOrderId] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const getValue = (cell) => {
    if (!cell) return "";
    return cell.f ?? cell.v ?? "";
  };

  const searchOrder = async () => {
    if (!orderId.trim()) {
      alert("Enter Order ID");
      return;
    }

    setLoading(true);

    try {
      const SHEET_ID = "1Mf1dv72iYIhLE1zY_RvcLwX9YTEWhL3oyIwSXE7WFmU";

      const url = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&sheet=Orders`;

      const res = await fetch(url);
      const text = await res.text();

      const json = JSON.parse(text.substring(47).slice(0, -2));

      const rows = json.table.rows;

      let found = null;

      rows.forEach((row) => {
        if (String(getValue(row.c[0])).trim() === orderId.trim()) {
          found = {
            orderId: getValue(row.c[0]),
            date: getValue(row.c[1]),
            time: getValue(row.c[2]),
            name: getValue(row.c[3]),
            mobile: getValue(row.c[4]),
            address: getValue(row.c[5]),
            item: getValue(row.c[6]),
            price: getValue(row.c[7]),
            qty: getValue(row.c[8]),
            total: getValue(row.c[9]),
            payment: getValue(row.c[10]),
            status: getValue(row.c[11]),
          };
        }
      });

      if (!found) {
        alert("Order Not Found");
        setOrder(null);
      } else {
        setOrder(found);
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong");
    }

    setLoading(false);
  };

  const statusColor = () => {
    if (!order) return "#777";

    switch (order.status) {
      case "Delivered":
        return "#2ecc71";
      case "Preparing":
        return "#3498db";
      case "Pending":
        return "#f39c12";
      case "Cancelled":
        return "#e74c3c";
      default:
        return "#7f8c8d";
    }
  };

  return (
    <div
      style={{
        background: "#f5f6fa",
        minHeight: "100vh",
        padding: "40px 15px",
      }}
    >
      <div
        style={{
          maxWidth: 650,
          margin: "auto",
          background: "#fff",
          borderRadius: 15,
          padding: 25,
          boxShadow: "0 10px 25px rgba(0,0,0,.15)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#782a2a",
            marginBottom: 20,
          }}
        >
          ✨ Track Your Order
        </h2>

        <input
          type="text"
          placeholder="Enter Order ID"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 8,
            border: "1px solid #ddd",
            fontSize: 16,
            marginBottom: 15,
          }}
        />

        <button
          onClick={searchOrder}
          style={{
            width: "100%",
            padding: 13,
            border: "none",
            borderRadius: 8,
            background: "#782a2a",
            color: "#fff",
            fontSize: 16,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {loading ? "Searching..." : "Track Order"}
        </button>

        {order && (
          <div
            style={{
              marginTop: 25,
              borderTop: "1px solid #eee",
              paddingTop: 20,
            }}
          >
            <Info title="Order ID" value={order.orderId} />
            <Info title="Date" value={order.date} />
            <Info title="Time" value={order.time} />
            <Info title="Customer" value={order.name} />
            <Info title="Mobile" value={order.mobile} />
            <Info title="Address" value={order.address} />
            <Info title="Item" value={order.item} />
            <Info title="Price" value={`₹${order.price}`} />
            <Info title="Qty" value={order.qty} />
            <Info title="Total" value={`₹${order.total}`} />
            <Info title="Payment" value={order.payment} />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 12,
              }}
            >
              <b>Status</b>

              <span
                style={{
                  background: statusColor(),
                  color: "#fff",
                  padding: "6px 15px",
                  borderRadius: 20,
                }}
              >
                {order.status}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Info({ title, value }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "10px 0",
        borderBottom: "1px solid #eee",
      }}
    >
      <b>{title}</b>
      <span>{value}</span>
    </div>
  );
}